export default __webpack_public_path__ + "static/media/cs_work.552e0418.png";